// components/industry-templates/GamingEventTemplate.tsx
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Gamepad2, Trophy, Users, Zap } from 'lucide-react';

export const GamingEventTemplate = ({ structure, theme }: any) => {
  const industryData = structure.industry_data;

  return (
    <div className="space-y-8">
      {/* Tournaments */}
      {industryData?.tournaments && (
        <Card className="border-0 bg-gradient-to-br from-purple-600/20 to-pink-600/20 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2 text-2xl">
              <Trophy className="w-8 h-8" style={{ color: theme.primary }} />
              Gaming Tournaments
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              {industryData.tournaments.map((tournament: any, idx: number) => (
                <div key={idx} className="p-5 bg-white/10 rounded-xl border-2" style={{ borderColor: theme.primary }}>
                  <div className="flex justify-between items-start mb-3">
                    <div>
                      <h3 className="text-2xl font-bold text-white mb-1">{tournament.game}</h3>
                      <p className="text-slate-300">{tournament.format}</p>
                    </div>
                    <Badge className="bg-yellow-500 text-black text-lg py-2 px-4">
                      {tournament.prize_pool}
                    </Badge>
                  </div>
                  <div className="flex gap-4 text-sm mt-4">
                    <div className="flex items-center gap-2 text-slate-300">
                      <Users className="w-4 h-4" />
                      <span>{tournament.teams} teams</span>
                    </div>
                    <div className="flex items-center gap-2 text-slate-300">
                      <Zap className="w-4 h-4" />
                      <span>{tournament.platform}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Game Demos */}
      {industryData?.game_demos && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white flex items-center gap-2">
              <Gamepad2 className="w-6 h-6" style={{ color: theme.primary }} />
              Playable Game Demos
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
              {industryData.game_demos.map((demo: string, idx: number) => (
                <div key={idx} className="p-4 bg-white/5 rounded-lg text-center border border-white/10 hover:scale-105 transition-transform">
                  <div className="text-2xl mb-2">🎮</div>
                  <p className="text-white font-medium text-sm">{demo}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      )}

      {/* Streamers */}
      {industryData?.special_guests && (
        <Card className="border border-white/10 bg-slate-900/50 backdrop-blur">
          <CardHeader>
            <CardTitle className="text-white">Special Guest Streamers</CardTitle>
          </CardHeader>
          <CardContent>
            <div className="flex flex-wrap gap-3">
              {industryData.special_guests.map((guest: string, idx: number) => (
                <Badge key={idx} style={{ backgroundColor: theme.primary }} className="text-lg py-2 px-4">
                  {guest}
                </Badge>
              ))}
            </div>
          </CardContent>
        </Card>
      )}
    </div>
  );
};
